<mat-form-field appearance="fill" class="modal-custom-class">
    <div class="comment-section">
        <textarea matInput placeholder="Descrie motivul respingerii" [(ngModel)]="comment"></textarea>
    </div>
    <button class="btn-send" (click)="sendOption()">Send</button>
</mat-form-field>